<template>
  <div class="order-main container">
    <el-form label-width="120px">
      <div class="form-item-title">询价单信息</div>
      <el-row>
        <el-col :span="10">
          <el-form-item label="询价单号:">{{
            routeData.enquiryNo
          }}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="询价单状态:">{{
            enquiryStatusOptions[routeData.enquiryStatus]
          }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="询价单名称:">{{
            routeData.enquiryName
          }}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="客户名称:">{{
            routeData.purchaseCompany
          }}</el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="10">
          <el-form-item label="询价类型:">{{
            routeData.enquiryType == 0 ? '定向询价' : '公开询价'
          }}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="评选类型:">{{
            routeData.evaluationSelectionType ==1 ? '系统评选（总价最低）' : '人工评选'
          }}</el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="10">
          <el-form-item label="报价开始时间:">
            {{ routeData.releaseTime }}
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="报价截止时间:">{{
            routeData.quotationDeadline
          }}</el-form-item> 
        </el-col>
      </el-row>

      
      <el-row>
        <el-col :span="10">
          <el-form-item label="希望到货日期:">
            {{ routeData.arrivalTime }}
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="报价轮数:">
            {{  $route.query.consultCount ? $route.query.consultCount*1+1 : routeData.consultCount ? routeData.consultCount*1+1 : 0 }}
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="10">
          <el-form-item label="付款方式:">
            {{ routeData.payType }}
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="结算方式:">
            {{
              routeData.isDoC != undefined
                ? routeData.isDoC === 1
                  ? '货到付款'
                  : '款到发货'
                : ''
            }}
          </el-form-item>
          <!-- 倒计时 -->
          <!-- <div class="stop-time">
            报价剩余时间：
            <count-down
              v-if="routeData.quotationDeadline"
              :stop-time="routeData.quotationDeadline"
            ></count-down>
            <span v-else>0天0小时0分0秒</span>
          </div> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="配送方式:">
            {{ formatShipmentType(routeData.shipmentType) }}
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="询价单限额:">
            {{ routeData.quotationLimit }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="联系人:">
            {{ routeData.realName }}
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="联系方式:">
            {{ routeData.mobile }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="地址:">{{ routeData.address }}</el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="邮箱:">{{ routeData.email }}</el-form-item>
        </el-col>
      </el-row>
     
      <el-row class="file-show">
        <el-col :span="16">
          <el-form-item label="上传附件:">
            <el-tooltip
              v-for="item of routeData.enquiryAttachmentList"
              :key="item.attachmentUrl"
              effect="dark"
              :content="item.attachmentName"
              placement="bottom"
              :disabled="checkTextOverflow(item.attachmentName)"
            >
              <span class="file-name" @click="downloadFile(item)">
                {{ item.attachmentName }}
              </span>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
       <!-- 采购商传的传的 -->
       <el-row>
        <el-col :span="24">
          <el-form-item label="备注:">{{
            routeData.enquiryRemark
          }}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import countDown from '@/modules/projectA/pages/order/enquiryPrice/countDown.vue';
export default {
  components: {
    countDown,
  },
  props: {
    routeData: {
      type: Object,
      default: () => {},
    },
  },
  data(){
    return {
      enquiryStatusOptions: {
        0: '待提交',
        1: '待审核',
        
        
        4: '待确认',
        5: '已完成',
        6: '已完成',
        8: '已终止',
        9: '已拒绝',
        12: '结果审核中',

        // 专门为华东小程序报价出的状态码
        15:'待开始',
        16:'询价中'
      },
    };
  },
  methods: {
    checkTextOverflow(str) {
      let count = 0; // 初始化字节数递加变量并获取字符串参数的字符个数
      if (str) {
        // 如果存在字符串，则执行
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 255) {
            // 字符编码大于255，说明是双字节字符(即是中文)
            count += 2;
          } else {
            count++;
          }
        }
      }
      return count <= 20;
    },
    downloadFile(fileObj) {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileObj.attachmentUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileObj.attachmentName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    formatShipmentType(type) {
      let str = '';
      if (type === 1) {
        str = '卖家自行配送';
      } else if (type === 3) {
        str = '第三方物流';
      }
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px 10px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.209933);
  .file-name {
    margin-right: 10px;
    color: #2587ff;
    cursor: pointer;
    display: block;
    // width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex-shrink: 0;
    flex-grow: 0;
  }
}
::v-deep .el-icon-close-tip {
  display: none;
}
.form-item-title {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}
::v-deep.el-form-item {
  margin-bottom: 0;
  word-break: break-all;
}
::v-deep.el-textarea {
  width: 90%;
}
::v-deep.el-form-item__label {
  padding: 0 5px 0 0 !important;
}
.stop-time {
  height: 24px;
  margin: 4px 0 4px 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #f0250f;
}

</style>
